module.exports = __webpack_public_path__ + "img/awards-logo.f9907344.png";